export const maintenanceConfig = {
    isMaintenanceMode: false,
    message: "Probíhá aktualizace systému, po dobu několika minut může být systém zpomalen nebo nefunkční.",
    type: "error" // can be "warning", "error", "info"
};